import { motion } from 'framer-motion';
import { Shield, Zap, MapPin } from 'lucide-react';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-60px' },
  transition: { duration: 0.45, delay },
});

const ForThePeople = () => {
  return (
    <section className="bg-surface-alt dark:bg-dark-surface-alt py-12 lg:py-14 px-4">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">

          {/* ── LEFT: the story ── */}
          <div>
            <motion.span
              {...fadeUp(0)}
              className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4 bg-primary-tint dark:bg-primary/10 border border-primary/25 text-primary"
            >
              <Shield size={13} />
              Built For The People
            </motion.span>

            <motion.h2
              {...fadeUp(0.06)}
              className="font-display text-2xl sm:text-3xl font-semibold leading-tight text-ink dark:text-dark-ink mb-4"
            >
              Built locally, <span className="text-primary">run by the people who use it every day.</span>
            </motion.h2>

            <motion.p {...fadeUp(0.1)} className="text-base text-ink-soft dark:text-dark-ink-soft leading-relaxed mb-7 max-w-md">
              No corporate cuts, no outside investors taking a slice of every fare.
              The value stays with the drivers and riders who use it every day.
            </motion.p>

            <motion.div {...fadeUp(0.16)} className="grid grid-cols-2 gap-5 mb-7">
              <div>
                <div className="flex items-center justify-center w-9 h-9 rounded-control mb-3 bg-teal-tint dark:bg-teal/10 border border-teal/25">
                  <Shield size={16} className="text-teal-dark dark:text-teal" aria-hidden="true" />
                </div>
                <h3 className="text-sm font-bold text-ink dark:text-dark-ink mb-1">Zero drain</h3>
                <p className="text-xs text-ink-soft leading-relaxed">Profits stay local, not routed to outside investors.</p>
              </div>
              <div>
                <div className="flex items-center justify-center w-9 h-9 rounded-control mb-3 bg-primary-tint dark:bg-primary/10 border border-primary/25">
                  <Zap size={16} className="text-primary" aria-hidden="true" />
                </div>
                <h3 className="text-sm font-bold text-ink dark:text-dark-ink mb-1">Instant flow</h3>
                <p className="text-xs text-ink-soft leading-relaxed">Drivers get paid directly, with no wait times.</p>
              </div>
            </motion.div>

            <motion.div {...fadeUp(0.2)} className="flex items-center gap-2 pt-5 border-t border-line dark:border-dark-line">
              <MapPin size={14} className="text-ink-muted" aria-hidden="true" />
              <span className="text-sm text-ink-soft dark:text-dark-ink-soft">
                Crafted in <span className="font-bold text-ink dark:text-dark-ink">Bhagalpur, Bihar</span>
              </span>
            </motion.div>
          </div>

          {/* ── RIGHT: bounded illustration panel, same pattern as the hero ── */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.5 }}
            className="rounded-card bg-primary-tint/40 dark:bg-white/5 p-10"
          >
            <img
              src="/images/illustrations/community.svg"
              alt="The TotoWala community of drivers and riders"
              className="w-full h-auto block"
            />
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default ForThePeople;
